import React from 'react';

import { type MenuSkeletonItemProps } from '../../../types/menu-base';
import { MenuSkeletonItem } from './MenuSkeletonItem/MenuSkeletonItem';

export const SkeletonItem = (props: MenuSkeletonItemProps): React.JSX.Element => {
	return <MenuSkeletonItem {...props} />;
};
